import { BACKEND_URL } from '@/core/config';
import { server } from '../core/server/axios';
import { AcceptActionTypeBack, AcceptStatusBack } from '@/constatns';

export class AcceptController {
	async acceptList({ fromDate, toDate, actionType, depsId }: { fromDate: Date | null, toDate: Date | null, depsId: string[] | number[], actionType: AcceptActionTypeBack }): Promise<any> {
		return await server.post('/Accept/acceptList', { fromDate: fromDate, toDate: toDate, actionType, depId: depsId }, {
			baseURL: BACKEND_URL
		});
	}

	async bindAccept({ id, login }: { id: number, login: string }): Promise<any> {
		return await server.get(`/Accept/bindAccept/${id}/${login}`, {
			baseURL: BACKEND_URL
		});
	}

	async getAccept(id: string | number): Promise<any> {
		return await server.get(`/Accept/${id}`, {
			baseURL: BACKEND_URL
		});
	}

	async accept({
		id,
		status,
		comment,
		rate,
		rateUpdated,
		amount,
		amountUpdated,
		value,
		valueUpdated,
		depId,
	}: {
		id: number,
		status: AcceptStatusBack,
		comment: string,
		rate: number,
		rateUpdated: number,
		amount: number | null,
		amountUpdated: number | null,
		value: number | null,
		valueUpdated: number | null,
		depId: string | number
	}): Promise<any> {
		return await server.post('/Accept/accept', { id, status, comment, rate, rateUpdated, amount, amountUpdated, value, valueUpdated, depId }, {
			baseURL: BACKEND_URL
		});
	}
}